module.exports = __webpack_public_path__ + "static/img/v3.31c02fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v3.svg
// module id = 2/pi
// module chunks = 0